/* eslint-disable react/no-danger */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useMemo, useState } from 'react';
import { Button, Col, Input, Row, Label } from 'reactstrap';
import { TOOLTIPS_TEXT } from '../../../../../../../lib/constants';
import AddSecurityCodeModal from '../../../../../../AddSecurityCodeModal';
import ConfirmationModal from '../../../../../../ConfirmationModal';
import CustomModal from '../../../../../../CustomModal';
import InfoPopup from '../../../../../../InfoPopup';
import SpinnerCircles from '../../../../../../Spinner/SpinerCircles';
import { BUTTON_TEXT, MODAL_BODY_TEXT } from '../../constants';
import { useResetToDefault } from '../../hooks';
import './index.css';

/* Sub Components */
const ModalWithInput = ({ bodyText, handleChange }) => {
  const normalizedBodyText = useMemo(() => {
    let data = bodyText;
    if (bodyText.includes('Default')) {
      data = bodyText.replace('Default', '<b>Default</b>');
    }
    return data;
  }, []);

  const sanitizeData = () => {
    return {
      __html: normalizedBodyText,
    };
  };
  return (
    <div className="wrapper reset-modal">
      <Row>
        <Col lg={7} md={7} sm={4}>
          <p style={{ whiteSpace: 'nowrap' }} dangerouslySetInnerHTML={sanitizeData()} />
        </Col>
        <Col lg={5} md={5} sm={4}>
          <Input required type="text" name="validation" onChange={handleChange} />
        </Col>
      </Row>
    </div>
  );
};

const ModalWithNotesInput = ({ bodyText, handleChange }) => {
  return (
    <>
      <Row>
        <p>{bodyText}</p>
      </Row>
      <Row>
        <Label check sm={3}>
          <Input type="radio" name="logNotes" onChange={() => handleChange('keep')} />
          Keep Notes
        </Label>
        <Label check sm={3}>
          <Input type="radio" name="logNotes" onChange={() => handleChange('wipe')} />
          Wipe Notes
        </Label>
      </Row>
    </>
  );
};

/* Component */
export const ResetBoxToDefault = ({ loading, setDcUpdatePopup }) => {
  const [resetNotesType, setResetNotesType] = useState('');
  const [resetBoxResult, setResetBoxResult] = useState(null);

  const {
    handlerState,
    isModalTypeOnStepTwo,
    onWarningModalConfirm,
    handleResetInputChange,
    securityModalOnConfirm,
    showStepOneWarningModal,
    closeSecurityModalAndResetState,
    hideAndResetWarningModalToDefaultType,
    changeBoxOptionsAndRefreshBox,
  } = useResetToDefault({ resetNotesType, setResetNotesType, setResetBoxResult });

  const { showWarningModalForReset, showSecurityModal } = handlerState;

  const handleChange = item => setResetNotesType(item);

  const shouldComponentBeSentAsProp = useCallback(() => {
    if (!isModalTypeOnStepTwo)
      return <ModalWithNotesInput bodyText={MODAL_BODY_TEXT.DEFAULT} handleChange={handleChange} />;
    return (
      <ModalWithInput bodyText={MODAL_BODY_TEXT.SECODARY} handleChange={handleResetInputChange} />
    );
  }, [isModalTypeOnStepTwo]);

  return (
    <div className="modam-row mt-2 mb-2 mr-1">
      <h1 className="heading d-flex">
        Reset To Default
        <sup>
          <InfoPopup id="resettodefault" text={TOOLTIPS_TEXT.RESET_BOX_TO_DEFAULT} />
        </sup>
      </h1>
      <Button
        disabled={loading}
        onClick={ () => {
          const divElement = document.getElementById('test-time-remaining');
          const isHidden = divElement.getAttribute('hidden') !== null;
          if (isHidden) {
            setDcUpdatePopup({ show: true });
          } else {
            showStepOneWarningModal()
          }

        }}
        color="danger"
        className="admin-tool-execute-btn"
      >
        {loading ? <SpinnerCircles /> : BUTTON_TEXT.EXECUTE}
      </Button>

      {/* Confirmation Modal */}
      {showWarningModalForReset && (
        <ConfirmationModal
          customBodyComponent={shouldComponentBeSentAsProp()}
          resetBoxComponent
          confirmBtnText={isModalTypeOnStepTwo ? BUTTON_TEXT.GO : BUTTON_TEXT.EXECUTE}
          isOpen={showWarningModalForReset}
          onCancel={hideAndResetWarningModalToDefaultType}
          onConfirm={onWarningModalConfirm}
          warning={showWarningModalForReset}
          disableConfirmBtn={!resetNotesType}
        />
      )}

      {/* Security Modal */}
      {showSecurityModal && (
        <AddSecurityCodeModal
          isOpen={showSecurityModal}
          onConfirm={securityModalOnConfirm}
          onCancel={closeSecurityModalAndResetState}
          resetBoxToDefault={showSecurityModal}
          featureName={'resetBoxToDefault'}
        />
      )}

      {/* Result Modal */}
      {resetBoxResult && (
        <CustomModal
          isOpen={!!resetBoxResult}
          header="Reset Box Result"
          showCustomButton
          customButtonText="OK"
          onCancel={changeBoxOptionsAndRefreshBox}
        >
          <Label className="font-weight-bold">Success Reset Logs</Label>
          <ul className="success-logs-items">
            {resetBoxResult?.success &&
              resetBoxResult?.success.map((action, idx) => {
                return (
                  <li key={idx}>
                    <FontAwesomeIcon
                      icon="check"
                      size="lg"
                      color="#198754"
                      style={{ marginRight: '1rem' }}
                    />
                    {action}
                  </li>
                );
              })}
          </ul>

          <Label className="font-weight-bold">Failed Reset Logs</Label>
          <ul className="error-logs-items">
            {resetBoxResult?.error &&
              resetBoxResult?.error.map((action, idx) => {
                return (
                  <li key={idx}>
                    <FontAwesomeIcon
                      icon="times"
                      size="lg"
                      color="#dc3545"
                      style={{ marginRight: '1rem' }}
                    />
                    {action}
                  </li>
                );
              })}
          </ul>
        </CustomModal>
      )}
    </div>
  );
};
